import * as React from 'react';

//@ts-expect-error FIXME: исправить импорт картинок
import failedIcon from './assets/failed.svg';
//@ts-expect-error FIXME: исправить импорт картинок
import fullfilledIcon from './assets/fullfilled.svg';
//@ts-expect-error FIXME: исправить импорт картинок
import readIcon from './assets/read.svg';
import { TOutcomingStatus, EOutcomingStatus } from '../../types/messages';

type TMessageStatusIconProps = {
  status: TOutcomingStatus;
};

const STATUS_ICON: Record<TOutcomingStatus, string | undefined> = {
  [EOutcomingStatus.Failed]: failedIcon,
  [EOutcomingStatus.Fulfilled]: fullfilledIcon,
  [EOutcomingStatus.Read]: readIcon,
  [EOutcomingStatus.Pending]: undefined,
};

export const MessageStatusIcon: React.FC<TMessageStatusIconProps> = ({ status }) => {
  return <img src={STATUS_ICON[status]} />;
};
